import React from 'react';
import { Route, Switch } from 'react-router';

import { routes } from '../../lib/routes';

import { AppMetricaDocPage } from './AppMetricaDocPage';
import { DocumentationMenu } from './DocumentationMenu';
import { GrammarDocPage } from './GrammarDocPage';
import { StateDocPage } from './StateDocPage';

export const DocumentationPage: React.FC = () => {
    const displayIntentsDocumentation = Boolean(
        __appConfig.app.displayGrammarPage || __appConfig.user.featureFlags.allowUseGrammarPage,
    );

    return (
        <Switch>
            <Route
                exact
                path={routes.app.documentation('')}
                render={() => {
                    return (
                        <DocumentationMenu
                            displayAppmetrica={true}
                            displayIntents={displayIntentsDocumentation}
                            displayState={true}
                        />
                    );
                }}
            />
            {displayIntentsDocumentation && (
                <Route path={routes.app.documentation('nlu')} exact component={GrammarDocPage} />
            )}
            <Route path={routes.app.documentation('appmetrica')} exact component={AppMetricaDocPage} />
            <Route path={routes.app.documentation('state')} exact component={StateDocPage} />
        </Switch>
    );
};
